import React from "react";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Heading4 from "../../../../designsystem/typography/KC-Heading/KC_Heading4";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";
import getDefaultTitleForCTA from "../../../../utils/helpers/getDefaultTitleForCTA";
import { TokenHistoryLabel } from "kadow-jetpack-model";
import AnalyticsData from "../../model/AnalyticsData";
import KC_DashboardCardSmall from "../../../../designsystem/KC_Card/KC_DashboardCardSmall";
import { tt } from "../../../../utils/i18n/i18n";

interface Props {
  data: AnalyticsData | undefined | null;
}

export default function Top3CTAs(props: Props) {
  const renderCta = (idx: number) => {
    if (!props.data) {
      return null;
    }

    const cta = props.data?.distributionOfCTAs?.[idx];

    if (!cta) {
      return null;
    }

    return (
      <KC_DashboardCardSmall
        title={getDefaultTitleForCTA(cta._id as TokenHistoryLabel)}
        text={cta.count}
        className="flex-grow-1"
        isHorizontal={true}
        style={{
          flex: 1
        }}
      />
    );
  };

  return (
    <>
      <div className="w-100 d-flex d-lg-none flex-column flex-lg-column st-gap k-dashboard-top-statistics-second-row">
        {renderCta(0)}
        {renderCta(1)}
        {renderCta(2)}
      </div>
      <div className="d-none d-lg-flex flex-column kc-card-dashboard">
        <TwemojiWrapper isText={true}>
          <KC_Heading3
            text={tt("analytics_top_3_actions")}
            className="text-center text-sm-left mb-2"
          />
        </TwemojiWrapper>
        {[0, 1, 2].map((idx) =>
          !!props.data?.distributionOfCTAs?.[idx] ? (
            <div className="w-100 d-flex flex-row justify-content-between">
              <KC_Heading4
                text={getDefaultTitleForCTA(
                  props.data.distributionOfCTAs[idx]._id as TokenHistoryLabel
                )}
              />
              <KC_Heading3
                text={props.data.distributionOfCTAs[idx].count}
                primary={true}
              />
            </div>
          ) : null
        )}
      </div>
    </>
  );
}
